// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__1XlYw","signatureBlock":"Footer_signatureBlock__Ws4Ig","signature":"Footer_signature__3Cy8V"};